document.addEventListener('DOMContentLoaded', () => {
  const isSectionGroup = (el) => el && [...el.classList].some((name) => name.startsWith('shopify-section-group'))

  const findPreviousSection = (section) => {
    const wrap = section.closest('.shopify-section')
    if (!wrap) return null

    let previous = wrap.previousElementSibling
    if (previous?.classList.contains('shopify-section')) return previous

    const group = wrap.parentElement
    if (isSectionGroup(group)) {
      previous = group.previousElementSibling
      if (previous?.classList.contains('shopify-section')) return previous
    }

    return null
  }

  const findHeldSections = () => {
    const held = []

    document.querySelectorAll('[data-overlap-previous]').forEach((section) => {
      const previous = findPreviousSection(section)
      if (previous) held.push(previous)
    })

    return held
  }

  const measure = (section) => {
    section.style.setProperty('--overlap-hold-height', `${section.offsetHeight}px`)
    section.setAttribute('data-overlap-held', '')
  }

  const observer = new ResizeObserver((entries) => entries.forEach((entry) => measure(entry.target)))

  let held = []

  const refresh = () => {
    observer.disconnect()
    held.forEach((section) => {
      section.removeAttribute('data-overlap-held')
      section.style.removeProperty('--overlap-hold-height')
    })

    held = findHeldSections()
    held.forEach((section) => {
      measure(section)
      observer.observe(section)
    })

    if (window.ScrollTrigger) window.ScrollTrigger.refresh()
  }

  const setup = () => {
    if (window.whenScrollReady) window.whenScrollReady(refresh)
    else refresh()
  }

  setup()

  document.addEventListener('shopify:section:load', setup)
  document.addEventListener('shopify:section:unload', setup)
})
